import {MaterialModel} from "../collected-data-model";

export class GeneralMeasurementModel {
  installationMaterial: MaterialModel;

  constructor() {
    this.installationMaterial = new MaterialModel();
    this.installationMaterial.materialType = "INSTALLATION";
  }

  public static initialize(model: GeneralMeasurementModel): void {
    if (!model.installationMaterial) {
      model.installationMaterial = new MaterialModel();
    }
    model.installationMaterial.materialType = "INSTALLATION";
  }
}

